function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".poster-session-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M4.05,57.33H18.92V52.41a8.29,8.29,0,0,0-8.2-8.31,8.39,8.39,0,0,0-8.31,8.31v3.28A1.63,1.63,0,0,0,4.05,57.33Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M15.64,39.18a4.92,4.92,0,0,0-4.92-4.92,4.92,4.92,0,1,0,0,9.84A4.92,4.92,0,0,0,15.64,39.18Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M22.2,52.41v4.92H38.72V52.41a8.39,8.39,0,0,0-8.31-8.31A8.3,8.3,0,0,0,22.2,52.41Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M35.44,39.18a5,5,0,0,0-5-4.92,4.92,4.92,0,1,0,0,9.84A5,5,0,0,0,35.44,39.18Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M50.2,44.1A8.29,8.29,0,0,0,42,52.41v4.92H56.77a1.64,1.64,0,0,0,1.64-1.64V52.41A8.3,8.3,0,0,0,50.2,44.1Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M55.13,39.18a4.93,4.93,0,1,1-4.93-4.92A4.93,4.93,0,0,1,55.13,39.18Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M55.13,12.93A4.93,4.93,0,1,1,50.2,8,4.93,4.93,0,0,1,55.13,12.93Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M50.2,17.85a8.2,8.2,0,0,0-8.2,8.2V39.18a8.21,8.21,0,1,1,16.41,0V26.05A8.21,8.21,0,0,0,50.2,17.85Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "poster-session-1",
  d: "M4.05,27.69H38.72V26.05A11.45,11.45,0,0,1,42,18V3a1.64,1.64,0,0,0-1.64-1.64H4.05A1.64,1.64,0,0,0,2.41,3V26.05A1.63,1.63,0,0,0,4.05,27.69Zm18.15-18a1.64,1.64,0,0,1,3.28,0v9.84a1.64,1.64,0,0,1-3.28,0Zm-6.56,3.28a1.64,1.64,0,0,1,3.28,0v6.56a1.64,1.64,0,0,1-3.28,0ZM9.08,16.21a1.64,1.64,0,1,1,3.28,0v3.28a1.64,1.64,0,0,1-3.28,0Z"
});

var SvgSession = function SvgSession(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 62.15 58.61",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSession, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/session.808b73a0.svg";
export { ForwardRef as ReactComponent };